import { render, staticRenderFns } from "./InjuryBadge.vue?vue&type=template&id=1eb6e668&scoped=true"
import script from "./InjuryBadge.vue?vue&type=script&lang=js"
export * from "./InjuryBadge.vue?vue&type=script&lang=js"
import style0 from "./InjuryBadge.vue?vue&type=style&index=0&id=1eb6e668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb6e668",
  null
  
)

export default component.exports